import Notification from './Notification';
import Header from './Header';
import React, { FC, ReactElement, useEffect } from 'react';
import { Outlet, useLocation, useMatch } from 'react-router';
import UpgradeNotification from './UpgradeNotification';
import { useAuth0 } from '@auth0/auth0-react';
import Footer from './Footer';

const HIDE_HEADER_ROUTES: Set<string> = new Set(['/account-setup']);

const PageLayout: FC = (): ReactElement => {
  const { isAuthenticated } = useAuth0();
  const location = useLocation();

  const isChatPage: boolean = Boolean(useMatch('/messages'));
  const shouldShowHeaderNav: boolean = isAuthenticated && !HIDE_HEADER_ROUTES.has(location.pathname);

  useEffect(() => {
    document.body.classList.toggle('stop-scrolling', isChatPage);
    return (): void => document.body.classList.remove('stop-scrolling');
  }, [isChatPage]);

  return (
    <div className="d-flex flex-column" style={{ height: '100dvh', overflow: 'hidden' }}>
      <Notification />
      { shouldShowHeaderNav && <Header /> }
      <div className="d-flex flex-column flex-grow-1" style={{ minHeight: 0, overflow: 'auto' }}>
        <Outlet />
      </div>
      <Footer />
      <UpgradeNotification />
    </div>
  );
};

export default PageLayout;
